// Scala degli strati sovrapposti, in ordine crescente: chi sta piu' in basso
// nella lista si disegna sopra. Un elemento sovrapposto sceglie il livello che
// descrive il suo ruolo, non un numero: i numeri stanno nelle custom properties
// di index.css, cosi' anche i file .css (select, combobox, dashboard) leggono la
// stessa scala. Un livello nuovo si aggiunge nelle due sedi, come per Color.
export const ZIndex = {
  // Elemento reso inerte, sotto il flusso di pagina (una modale chiusa).
  HIDDEN: "var(--z-hidden)",

  // Sovrapposizioni interne al flusso di pagina: freccette, badge, icone che
  // devono stare sopra il fratello statico e nient'altro.
  CONTENT: "var(--z-content)",

  // Navbar sticky e menu applicativo: sopra il contenuto che scorre sotto.
  NAVBAR: "var(--z-navbar)",

  // Popover ancorati a un controllo: select, combobox, menu utente. Sopra la
  // navbar, perche' il controllo che li apre puo' starci dentro.
  POPOVER: "var(--z-popover)",

  // Dialog modali e i loro backdrop.
  DIALOG: "var(--z-dialog)",

  // Tooltip e hovercard: sopra anche la dialog che li ospita.
  TOOLTIP: "var(--z-tooltip)",

  // Ultimo strato: loader a tutta pagina e feedback di esito, che devono
  // restare visibili sopra qualsiasi altra cosa sia aperta.
  FEEDBACK: "var(--z-feedback)",
};
